<template>
  <live2d
    v-show="isLive2dVisible"
    :style="style"
    :model="['ShizukuTalk/shizuku-48', 'default']"
    :direction="direction"
    :size="size"
  ></live2d>
  <router-view />
</template>

<script>
/*
 * 项目中引用包时，将 import 内容替换
 * import live2d from 'vue-live2d'
 */
import live2d from "@/components/live2d/index";

export default {
  name: "App",
  components: {
    live2d,
  },
  data() {
    return {
      direction: "right",
      style: "position: fixed; bottom: 0; right: 0; zIndex: 11",
      width: 500,
      height: 500,
      size: 250,
      isLive2dVisible: true
    };
  },
  watch: {
    $route(to) {
      // 根据路由变化来更新 isLive2dVisible 的值
      if (to.path === "/login" || to.path === "/404") {
        this.isLive2dVisible = false;
      } else {
        this.isLive2dVisible = true;
      }
    },
  },
  created() {
    // tips 未使用，可自行在组件绑定此参数，注意此参数只会初始化一次
    this.tips = this.customTips;
  },
  methods: {
    _isMobile() {
      let isPC = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|Macintosh)/i);
      return isPC
    }
  },
  mounted () {
    if (this._isMobile()){
      this.$router.replace('/TerminalError')
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
body {
  margin: 0;
  padding: 0; /* 也可以顺便去掉padding，尽管这通常不是必需的 */
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif; /* 设定一个默认的字体家族，可选 */
  -webkit-font-smoothing: antialiased; /* 抗锯齿，可选 */
  -moz-osx-font-smoothing: grayscale; /* Firefox的抗锯齿，可选 */
}
</style>
